import React from 'react';
import namor from 'namor';
import Decimal from 'decimal';

export const getHenriColor = value => {
  console.log('value is ' + value);
  if (isNaN(value)) {
    let v = Number(value.split(',').join(''));
    if (
      v < 0 ||
      value === 'Red' ||
      value.split('m')[0] < 2 ||
      value.split('k')[0] < 2
    ) {
      return 'RED';
    } else if (v < 5000000 || value === 'YELLOW' || value.split('m')[0] < 5) {
      return 'YELLOW';
    } else if (v < 7000000 || value === 'GREEN' || value.split('m')[0] < 7) {
      return 'GREEN';
    } else if (v > 7000000 || value === 'BLUE' || value.split('m')[0] > 7) {
      return 'BLUE';
    } else {
      return 'GREY';
    }
  } else if (!isNaN(value)) {
    if (value < 2000000) {
      return 'RED';
    } else if (value < 5000000) {
      return 'YELLOW';
    } else if (value < 7000000) {
      return 'GREEN';
    } else if (value > 7000000) {
      return 'BLUE';
    } else {
      return 'GREY';
    }
  } else {
    return 'GREY';
  }
};
export const getHenriStyle = value => {
  if (value < 2.0 || value === 'RED' || value === 'Red') {
    return 'red';
  } else if (value < 5.0 || value === 'YELLOW' || value === 'Yellow') {
    return '#bca723';
  } else if (value < 7.0 || value === 'GREEN' || value === 'Green') {
    return 'green';
  } else if (value > 7.0 || value === 'BLUE' || value === 'Blue') {
    return '#48b5f7';
  } else {
    return 'grey';
  }
};

export const getCapColour = value => {
  let v = Number(value.split(',').join(''));
  if (v <= 0) {
    return 'RED';
  } else {
    return 'GREEN';
  }
};

const range = len => {
  const arr = [];
  for (let i = 0; i < len; i++) {
    arr.push(i);
  }
  return arr;
};

const newPerson = () => {
  const statusChance = Math.random();

  var positionList = ['RW', 'C', 'LW', 'D'];
  var teamList = ['London Blights', 'Erie Utters', 'Niagara IceFrogs'];
  var leagueList = ['OHL', 'AHL', 'WHL'];
  var henriList = ['BLUE', 'GREEN', 'YELLOW'];
  var handedList = ['L', 'R'];
  var statusList = ['UFA', 'RFA'];

  return {
    id:
      namor.generate({ words: 1, numbers: 0, manly: true }) +
      Math.floor(Math.random() * 30),
    firstName: namor.generate({ words: 1, numbers: 0, manly: true }),
    lastName: namor.generate({ words: 1, numbers: 0, manly: true }),
    name: namor.generate({ words: 2, numbers: 0, manly: true }),
    position: positionList[Math.floor(Math.random() * positionList.length)],
    team: teamList[Math.floor(Math.random() * teamList.length)],
    league: leagueList[Math.floor(Math.random() * leagueList.length)],
    age: Math.floor(Math.random() * 30),
    height:
      Math.floor(Math.random() * 2) +
      5 +
      "'" +
      Math.floor(Math.random() * 11) +
      '"',
    weight: Math.floor(Math.random() * 100) + 150,
    gamesPlayed: Math.floor(Math.random() * 30) + 35,
    goals: Math.floor(Math.random() * 40),
    assists: Math.floor(Math.random() * 60),
    points: Math.floor(Math.random() * 100),
    penaltyMinutes: Math.floor(Math.random() * 80),
    TO: Math.round(Math.random() * 100, 2) / 100,
    cap: Math.floor(Math.random() * 8000000),
    henri: Math.floor(Math.random() * 8000000),
    surplus: Math.floor(Math.random() * 8000000),
    handed: handedList[Math.floor(Math.random() * handedList.length)],
    status: statusList[Math.floor(Math.random() * statusList.length)],
    chartData: {
      labels: ['11-12', '12-13', '13-14', '14-15', '15-16', '16-17', '17-18'],
      prdCap: [
        Math.floor(Math.random() * 8000000),
        Math.floor(Math.random() * 8000000),
        Math.floor(Math.random() * 8000000),
        Math.floor(Math.random() * 8000000),
        Math.floor(Math.random() * 8000000),
        Math.floor(Math.random() * 8000000),
        Math.floor(Math.random() * 8000000)
      ],
      actCap: [
        Math.floor(Math.random() * 8000000),
        Math.floor(Math.random() * 8000000),
        Math.floor(Math.random() * 8000000),
        Math.floor(Math.random() * 8000000),
        Math.floor(Math.random() * 8000000),
        Math.floor(Math.random() * 8000000),
        Math.floor(Math.random() * 8000000)
      ],
      netSurplus: [
        Math.floor(Math.random() * 8000000),
        Math.floor(Math.random() * 8000000),
        Math.floor(Math.random() * 8000000),
        Math.floor(Math.random() * 8000000),
        Math.floor(Math.random() * 8000000),
        Math.floor(Math.random() * 8000000),
        Math.floor(Math.random() * 8000000)
      ]
    }
    /*  var lineChartData = {
    labels: ["2011-2012", "2012-2013", "2013-2014", "2014-2015", "2015-2016", "2016-2017", "2017-2018"],
    datasets: [{
        label: "Prd Cap",
        backgroundColor: "#DC143C",
        borderColor: "#DC143C",
        fill: false,
        data: [
        6115000,
        5960000 ,
        6613000 ,
        5850000 ,
        5630000 ,
        6500000 ,
        6300000
        ],
    }, {
        label: "Act Cap",
        backgroundColor: "#008000",
        borderColor: "#008000",
        fill: false,
        data: [
        5240000,
        5085000 ,
        1913000 ,
        1150000 ,
        930000 ,
        1800000 ,
        1600000
        ],
    }, {
        label: "Net Surplus",
        backgroundColor: "#4169E1",
        borderColor: "#4169E1",
        fill: false,
        data: [
        875000 ,
        875000 ,
        4700000 ,
        4700000 ,
        4700000 ,
        4700000 ,
        4700000
        ],
    }]
  };*/

    // age: Math.floor(Math.random() * 30),
    // games: Math.floor(Math.random() * 82),
    // goals: Math.floor(Math.random() * 100),
    // assists: Math.floor(Math.random() * 100)
  };
};

export function makeNRData(len = 10) {
  return range(len).map(d => {
    return {
      ...newPerson(),
      children: range(10).map(newPerson)
    };
  });
}

export function makeData(len = 200) {
  return range(len).map(d => {
    return {
      ...newPerson(),
      children: range(10).map(newPerson)
    };
  });
}

export function round(x) {
  if (
    isNaN(Number.parseFloat(x)) ||
    (Number.parseFloat(x) < 1000 && Number.parseFloat(x) > -1000)
  ) {
    return Number.parseFloat(0).toPrecision(3);
  } else if (
    Number.parseFloat(x)
      .toPrecision(3)
      .split('e')[1]
      .split('+')[1] < 6
  ) {
    return (
      Math.round(
        Number.parseFloat(x)
          .toPrecision(3)
          .split('e')[0] * 100
      ) + 'k'
    );
  } else if (
    Number.parseFloat(x)
      .toPrecision(3)
      .split('e')[1]
      .split('+')[1] < 7
  ) {
    return (
      Decimal(
        Number.parseFloat(x)
          .toPrecision(3)
          .split('e')[0]
      ) + 'm'
    );
  } else if (
    Number.parseFloat(x)
      .toPrecision(3)
      .split('e')[1]
      .split('+')[1] >= 7
  ) {
    return (
      Decimal(
        Number(
          (
            Number.parseFloat(x)
              .toPrecision(3)
              .split('e')[0] * 10
          ).toPrecision(3)
        )
      ) + 'm'
    );
  }
}



// WEBPACK FOOTER //
// ./src/Utility/utility.js